import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=032f4f82&scoped=true&"
import script from "./orderList.js?vue&type=script&lang=js&"
export * from "./orderList.js?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=032f4f82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032f4f82",
  null
  
)

export default component.exports